export var PredictLanguage;
(function (PredictLanguage) {
    PredictLanguage["Spanish"] = "es";
    PredictLanguage["Auto"] = "auto";
})(PredictLanguage || (PredictLanguage = {}));
export var PredictDomain;
(function (PredictDomain) {
    PredictDomain["Congress"] = "congress";
    PredictDomain["Twitter"] = "twitter";
})(PredictDomain || (PredictDomain = {}));
export var PredictMetric;
(function (PredictMetric) {
    PredictMetric["Rod"] = "rod";
    PredictMetric["Net"] = "net";
    PredictMetric["Trawl"] = "trawl";
})(PredictMetric || (PredictMetric = {}));
